import {
  ProductDetailsContainer,
  InvoiceIdentityData,
  CredentialsData,
  PurchaseSummary,
  PurchaseItems,
} from "./style";
import Verified from "../../assets/verified.svg";
import verifiedBra from "../../assets/bradesco/verified-bra.svg";
import verifiedClearsale from "../../assets/clearSale/verifyClear.svg";
import CheckedCircle from "../../assets/checked-circle.svg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchGetProofRequest } from "../../store/presentProof/getProofRequest/fetchCredential";

export function PurchaseDetails(props) {
  const dispatch = useDispatch();

  const presExId = useSelector(
    (state) => state.CreateProofRequest.data.presentation_exchange_id
  );

  const identity = useSelector(
    (state) =>
      state?.GetProofRequest.data.presentation?.requested_proof
        .revealed_attr_groups.identity.values
  );

  const address = useSelector(
    (state) =>
      state.GetProofRequest.data.presentation?.requested_proof
        .revealed_attr_groups.address.values
  );

  const creditCard = useSelector(
    (state) =>
      state.GetProofRequest.data.presentation?.requested_proof
        .revealed_attr_groups.credit_card.values
  );

  var status = props.status;

  const isVersionBradesco =
    process.env.REACT_APP_BRADESCO_ID === "true" ? true : false;

  const isVersionClearsale =
    process.env.REACT_APP_CLEARSALE === "true" ? true : false;
  // Replace the name except for the first four characters with asterisks
  function maskName(name) {
    let fullName = name;
    let firstFourCharacters = fullName.slice(0, 4);
    let remaining = fullName.slice(4).replace(/[\S]/g, "*");
    return firstFourCharacters + remaining;
  }

  // Replace the address except for the first two words with asterisks
  const maskedAddress = address?.endereco?.raw.replace(
    /^(\w+\s+\w+)\b([\w\s]*)/g,
    (match, firstTwoWords, remaining) => {
      const asterisks = remaining.replace(/\w+/g, (match) =>
        "*".repeat(match.length)
      );
      return firstTwoWords + " " + asterisks;
    }
  );

  useEffect(() => {
    dispatch(fetchGetProofRequest(presExId));
  }, [dispatch, presExId]);

  return (
    <ProductDetailsContainer>
      <CredentialsData>
        {process.env.REACT_APP_ZKP === "true" && (
          <div className="infoZKP">
            <img src={CheckedCircle} alt="" className="checkImg" />
            <p>Maioridade verificada e a compra autorizada</p>
          </div>
        )}
        <InvoiceIdentityData>
          <h1>
            Nota fiscal emitida para:
            {status === "success" ? (
              isVersionBradesco ? (
                <img src={verifiedBra} alt="icon user" />
              ) : isVersionClearsale ? (
                <img src={verifiedClearsale} alt="icon user" />
              ) : (
                <img src={Verified} alt="icon user" />
              )
            ) : null}
          </h1>
          <p className="note">
            {status === "success"
              ? "Enviamos sua nota fiscal eletrônica para seu e-mail."
              : "Enviaremos sua nota fiscal eletrônica para seu e-mail."}
          </p>
          {identity && (
            <>
              <p>
                <strong>Nome completo: </strong>
                {identity && maskName(identity.name.raw)}
              </p>
              <p>
                <strong>Telefone: </strong>
                {identity.telefone.raw.replace(
                  /\d(?=\d{0,3}(\d{4}|-|$))/g,
                  "*"
                )}
              </p>
              <p>
                <strong>E-mail: </strong>
                {identity.email.raw.replace(
                  /\B.+@/g,
                  (c) =>
                    c
                      .split("")
                      .slice(0, -1)
                      .map((v) => "*")
                      .join("") + "@"
                )}
              </p>
              <p>
                <strong>CPF: </strong>
                {identity.cpf.raw.replace(
                  /^(\d{3})\.\d{3}\.\d{3}-\d{2}$/,
                  "$1.***.***-**"
                )}
              </p>
            </>
          )}
        </InvoiceIdentityData>
        <InvoiceIdentityData>
          <h1>
            Produto em separação para entrega em:
            {status === "success" ? (
              isVersionBradesco ? (
                <img src={verifiedBra} alt="icon user" />
              ) : isVersionClearsale ? (
                <img src={verifiedClearsale} alt="icon user" />
              ) : (
                <img src={Verified} alt="icon user" />
              )
            ) : null}
          </h1>
          {address && (
            <>
              <p className="note">
                {status === "success"
                  ? "Acompanhe os próximos passos da entrega via e-mail."
                  : "Acompanhe os passos da entrega via e-mail."}
              </p>
              <p>
                <strong>CEP: </strong>
                {address.cep.raw.replace(/\d(?=(?:\D*\d){3})/g, "*")}
              </p>
              <p>
                <strong>Endereço: </strong>
                {maskedAddress}
              </p>
              <p>
                <strong>Cidade: </strong>
                {address.cidade.raw}
              </p>
              <p>
                <strong>UF: </strong>
                {address.estado.raw}
              </p>
            </>
          )}
        </InvoiceIdentityData>
        <InvoiceIdentityData>
          <h1>
            Método de Pagamento:{" "}
            {status === "success" ? (
              isVersionBradesco ? (
                <img src={verifiedBra} alt="icon user" />
              ) : isVersionClearsale ? (
                <img src={verifiedClearsale} alt="icon user" />
              ) : (
                <img src={Verified} alt="icon user" />
              )
            ) : null}
          </h1>
          {creditCard && (
            <>
              <p>
                <strong>Nº: </strong>
                {creditCard.numero_do_cartao.raw.replace(
                  /\d(?=(?:\D*\d){4})/g,
                  "*"
                )}
              </p>
              <p>
                <strong>Nome no cartão: </strong>
                {maskName(creditCard.nome_no_cartao.raw)}
              </p>
              <p>
                <strong>Data de validade: </strong>
                {creditCard.data_de_validade.raw.replace(
                  /\d{2}\/\d{4}/g,
                  "**/****"
                )}
              </p>
              <p>
                <strong>Parcelamento: </strong>1 x de R${" "}
                {props.summary[0].productPrice}
              </p>
            </>
          )}
        </InvoiceIdentityData>
      </CredentialsData>
      <PurchaseSummary>
        <p>Resumo da compra</p>
        <hr />
        {props.summary.map((product) => (
          <PurchaseItems key={product.id}>
            <img src={product.img} alt={product.productName} />
            <p className="productName"> {product.productName} </p>
            <p>
              {" "}
              Cód: {product.productCode} - {product.productBrand}{" "}
            </p>
            <p className="price">R$ {product.productPrice}</p>
            <hr />
          </PurchaseItems>
        ))}
        <p className="fullPrice">Total: R$ {props.summary[0].productPrice}</p>
      </PurchaseSummary>
    </ProductDetailsContainer>
  );
}
